export default "__VITE_ASSET__0N1a6htx__"